module.exports = __webpack_public_path__ + "img/cloud upload.1170d9db.svg";